export const pageData = {
  dashboard: {
    title: 'Dashboard',
    description: 'Overview of your workspace.',
    stats: ['Total Users', 'Total Projects', 'Total Vendors'],
  },
  allProjects: {
    title: 'All Projects',
    description: 'Browse all projects in one place.',
    stats: ['Web Redesign', 'CRM Migration', 'Mobile App', 'SEO Sprint'],
  },
  createProject: {
    title: 'Create Project',
    description: 'Use this page to start a new project workflow.',
    stats: ['Template A', 'Template B', 'Template C', 'Custom Setup'],
  },
  archivedProjects: {
    title: 'Archived Projects',
    description: 'Past projects kept for history and reports.',
    stats: ['Legacy Portal', 'v1 API', 'Old Dashboard', 'QA Demo'],
  },
  members: {
    title: 'Team Members',
    description: 'Manage your workspace members.',
    stats: ['Design Team', 'Frontend Team', 'Backend Team', 'Marketing Team'],
  },
  roles: {
    title: 'Roles & Access',
    description: 'Define permissions by role for each module.',
    stats: ['Admin', 'Manager', 'Editor', 'Viewer'],
  },
  settings: {
    title: 'Settings',
    description: 'Configure project-wide preferences.',
    stats: ['General', 'Notifications', 'Security', 'Integrations'],
  },
};
